import React from 'react';
import { Button, CenteredCard, Logo } from './components/ui';
import { colors, type, heading } from './theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Post to API error endpoint (fire-and-forget)
    fetch(`${API_URL}/api/errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: error.message,
        stack: error.stack,
        componentStack: info.componentStack,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      }),
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      return (
        <CenteredCard width="420px" style={{ textAlign: 'center' }}>
          <Logo variant="mark" size={40} style={{ margin: '0 auto 20px' }} />
          <h1 style={{ ...heading.display, marginBottom: '8px' }}>Something went wrong</h1>
          <p style={{ fontSize: type.base, color: colors.textSecondary, lineHeight: 1.5, marginBottom: '24px' }}>
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <Button variant="primary" onClick={() => window.location.reload()}>Reload</Button>
        </CenteredCard>
      );
    }
    return this.props.children;
  }
}
